export default "__VITE_ASSET__Pg_1xYd8__"